// extracted by mini-css-extract-plugin
export default {"container":"RnDoffers_container__QEN+t","offers-box":"RnDoffers_offers-box__LC7F9"};